module.exports = __webpack_public_path__ + "img/lollipop.55a56628.png";